"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DownloadButton = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _culture = require("@ori/culture");
var _renderer = require("@react-pdf/renderer");
var _react = require("react");
var _concernFormContext = require("../../contexts/concernFormContext");
var _useTranslations = require("../../hooks/useTranslations");
var _utils = require("../../utils");
var _components2 = require("./components");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file -- not testable in jest environment */ const DownloadButton = ()=>{
    const { concernFormData, sentValues } = (0, _concernFormContext.useConcernForm)();
    const { culture, timeZone } = (0, _culture.useCulture)();
    const footer = (0, _culture.formatDate)(new Date(), _culture.DateFormat.ShortDateLongTime, culture, timeZone);
    const dataCollection = (0, _react.useMemo)(()=>(0, _utils.mapAnswersToDataCollection)({
            questions: concernFormData.questions,
            formValues: sentValues
        }), [
        concernFormData.questions,
        sentValues
    ]);
    const [doc] = (0, _renderer.usePDF)({
        document: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components2.ReportAConcernPdf, {
            title: concernFormData.introductionTitle,
            dataCollection: dataCollection,
            footer: footer
        })
    });
    const { translations } = (0, _useTranslations.useTranslations)();
    var _doc_url;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        download: true,
        href: (_doc_url = doc.url) !== null && _doc_url !== void 0 ? _doc_url : '/',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
            color: "primary",
            startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Download, {}),
            variant: "contained",
            disabled: doc.loading,
            children: translations.downloadPdf
        })
    });
};
exports.DownloadButton = DownloadButton;
